import PropTypes from 'prop-types';
import React from 'react';
import BackToTop from '@bibliocommons/base-back-to-top';
import { TOGGLZ_FEATURES } from '@bibliocommons/constants-feature-togglz';
import FeatureTogglz from '@bibliocommons/feature-togglz';
import Context from '@bibliocommons/context';

import { DataLayerContainer } from 'app/components/analytics/DataLayer';
import { CoreHeaderContainer } from 'app/components/layouts/CoreHeader';
import { DocumentHeadContainer } from 'app/components/shared/DocumentHead';
import { ErrorBoundaryContainer } from 'app/components/errors/ErrorBoundary';
import { FooterContainer } from 'app/components/layouts/Footer';
import { GlobalProgressBarContainer } from 'app/components/layouts/GlobalProgressBar';
import { GlobalMessagingContainer } from 'app/components/GlobalMessaging';
import LoginOverlayContainer from 'app/components/deprecated/LoginOverlay/LoginOverlayContainer';
import StaffTakeoverMessageContainer from 'app/components/shared/StaffTakeoverMessage/StaffTakeoverMessageContainer';
import ScreenReaderShortcutsContainer from 'app/components/shared/ScreenReaderShortcuts/ScreenReaderShortcutsContainer';
import { SystemMessagesContainer } from 'app/components/shared/SystemMessages';
import PrivacySettingsModalContainer from 'app/components/bibs/shared/ugc/PrivacySettingsModal';
import IEDiscontinuedMessage from 'app/components/shared/IEDiscontinuedMessage';

let MainLayout = null;

if (__SERVER__ || __ENHANCED_ASSETS__) {
  // eslint-disable-next-line global-require
  MainLayout = require('app/components/layouts/MainLayout').default;
} else {
  // eslint-disable-next-line global-require
  require('app/deprecated/assets/stylesheets/app.scss');
}

class MainLayoutDeprecated extends React.PureComponent {
  renderDeprecated() {
    return (
      <div>
        <IEDiscontinuedMessage />
        <DataLayerContainer />
        <DocumentHeadContainer />
        {!this.context.mobileApp && <ScreenReaderShortcutsContainer />}
        <GlobalProgressBarContainer />
        <StaffTakeoverMessageContainer />
        <CoreHeaderContainer />
        <div id="preview-bar" />
        <SystemMessagesContainer />
        <section id="content" tabIndex="-1">
          <ErrorBoundaryContainer>{this.props.children}</ErrorBoundaryContainer>
        </section>
        <GlobalMessagingContainer />
        <LoginOverlayContainer />
        <FooterContainer />
        <BackToTop />
        <PrivacySettingsModalContainer />
      </div>
    );
  }

  renderEnhanced() {
    return <MainLayout {...this.props} />;
  }

  render() {
    return (
      <FeatureTogglz>
        {features =>
          features.get(TOGGLZ_FEATURES.NERF_GLOBAL_UI_UPDATES) ? this.renderEnhanced() : this.renderDeprecated()}
      </FeatureTogglz>
    );
  }
}

MainLayoutDeprecated.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

MainLayoutDeprecated.contextType = Context;

export default MainLayoutDeprecated;
